module.exports = __webpack_public_path__ + "img/text_02.4765fab8.png";